import { render, staticRenderFns } from "./CheckboxItem.vue?vue&type=template&id=54f3dadb&scoped=true&"
import script from "./CheckboxItem.vue?vue&type=script&lang=js&"
export * from "./CheckboxItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxItem.vue?vue&type=style&index=0&id=54f3dadb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3dadb",
  null
  
)

export default component.exports